import { Envs } from '../../envs'

export const getPayCheckoutUrl = () => Envs.PAY_CHECKOUT_URL ?? 'http://localhost:3002'
